document.addEventListener('DOMContentLoaded', function () {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '#pswp-gallery',
      children: 'a',
      pswpModule: PhotoSwipe,
      bgOpacity: 0.8,
      showHideAnimationType: 'zoom',
    });
    lightbox.init();
  });